import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import "@/i18n";
import "@/App.css";

import LanguageLayout from "@/components/LanguageLayout";
import ScrollToTop from "@/components/ScrollToTop";
import CookieConsent from "@/components/CookieConsent";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import TermsConditions from "@/pages/TermsConditions";
import ThankYou from "@/pages/ThankYou";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/ar" replace />} />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path="/:lang" element={<LanguageLayout />}>
          <Route index element={<Home />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="cookie-policy" element={<CookiePolicy />} />
          <Route path="terms-conditions" element={<TermsConditions />} />
          <Route path="*" element={<Navigate to="/ar" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/ar" replace />} />
      </Routes>
      <CookieConsent />
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
